export const INFO_CONTENT = {
  GRIPPER_FABRICS: {
    title: "Gripper Fabric Disclaimer:",
    content: `
      <p>The customizer is a visual representation and not an exact replica of your seat or seat cover. This means the colors and designs may vary based on the shape and size of your seat.</p>
      <ul>
        <li>UV Protected Colors:
          <ul>
            <li>Red, Orange, Yellow, KX Green and Pink</li>
          </ul>
        </li>
        <li>Needs Extra Care:
          <ul>
            <li>Flo Green and Highlighter</li>
            <li>These colors are more subject to fading if left in direct sunlight for extended periods of time.</li>
          </ul>
        </li>
        <li>All other colors and shades don't require UV protection, as they are not prone to fading.</li>
      </ul>
      <p>Our seat covers are durable but can only handle so much :)</p>
    `,
  },
  CANVAS_NON_GRIPPER: {
    title: "Canvas Non-Gripper Disclaimer:",
    content: `
      <p>Patterns on the customizer are a visual representation and not an exact replica of your seat or seat cover. This means the colors and designs may vary based on the shape and size of your seat.</p>
      <p>This material is slightly less grippy and requires extra care to avoid fading over time.</p>
    `,
  },
  CUSTOM_TEXT: {
    title: "Custom Text Disclaimer:",
    content: `
      <p>We DO NOT print any text that promotes or condones hate speech, discrimination, or violence.</p>
    `,
  },
  CUSTOM_IMAGE: {
    title: "Custom Image Disclaimer:",
    content: `
      <p>Our design team will use their own discretion when printing and will not print patches if it contains hate, nudity, and logos of MAJOR brands.</p>
      <p>By uploading images to the customizer, you acknowledge and agree to the following:</p>
      <ul>
        <li>You are the sole copyright owner of the uploaded image or you have obtained the necessary permissions to use and upload it.</li>
        <li>Thrill Seekers is not responsible for any copyright infringements, privacy violations, or other legal issues arising from the use of the uploaded images. You are solely responsible for ensuring that your uploaded images comply with all applicable laws and regulations.</li>
      </ul>
    `,
  },
};
